<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="overlayClicked(false)"></div>
      <div class="modalContent">
        <div class="success-animation">
          <div class="loading" v-if="loading"></div>
          <svg class="checkmark" v-else xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"><circle class="checkmark__circle"
            cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check"
            fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
        </div>
        <template v-if="title || desc">
          <template v-if="loading">
            <template v-if="lang === 'id'">
              <h4>Mengirimkan data</h4>
              <p>Mohon tunggu...<br />Jangan tutup browser sampai proses selesai.</p>
            </template>
            <template v-else>
              <h4>Sending data</h4>
              <p>Please wait...<br />Keep the browser open while sending data.</p>
            </template>
          </template>
          <template v-else>
            <h4 v-if="title">{{title}}</h4>
            <p v-if="desc">{{desc}}</p>
            <button class="btn secondary" v-on:click="close(false)">
              <span v-if="lang === 'id'">Tutup</span>
              <span v-else>Close</span>
            </button>
          </template>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'loadingDialog',
  components: {
  },
  data() {
    return {
      show: false,
      next: null,
      loading: true,
      title: '',
      desc: '',

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    open(d, n) {
      this.next = n;
      this.show = true;
      this.loading = d && d.loading ? d.loading : false;
      this.title = d && d.title ? d.title : '';
      this.desc = d && d.desc ? d.desc : '';
    },
    stopLoading() {
      this.loading = false;
    },
    overlayClicked() {
      if (this.loading) return;
      this.close(false);
    },
    close(b) {
      this.show = false;
      if (this.next) this.next(b);
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      text-align: center;
      overflow: hidden;
      max-width: none;
      padding: 80px 40px 60px;
      border-radius: 5px;
      margin-top: -20px;
      min-height: 40px;
      width: 360px;
      color: #444;
      @media (max-width: 460px) {
        box-sizing: border-box;
        width: calc(100% - 20px);
      }
      h4{
        margin: 0 0 4px;
        font-size: 20px;
        font-weight: 500;
      }
      p{
        margin: 0 0 16px;
        color: #767676;
        font-size: 15px;
        line-height: 1.36;
      }
      .success-animation{
        margin-bottom: 24px;
        position: relative;
        height: 100px;
        .loading{
          width: 138px; height: 138px;
          background-image: url(../assets/loading-thin.svg);
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
          margin: 0 auto;
          position: absolute;
          left: 50%; top: -19px;
          transform: translateX(-50%);
        }
        .checkmark{
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: block;
          stroke-width: 2;
          stroke: #4bb71b;
          stroke-miterlimit: 10;
          box-shadow: inset 0px 0px 0px #4bb71b;
          animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
          margin: 0 auto;
        }
        .checkmark__circle{
          stroke-dasharray: 166;
          stroke-dashoffset: 166;
          stroke-width: 2;
          stroke-miterlimit: 10;
          stroke: #4bb71b;
          fill: #fff;
          animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }
        .checkmark__check{
          transform-origin: 50% 50%;
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
        @keyframes stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }
        @keyframes scale {
          0%, 100% {
            transform: none;
          }
          50% {
            transform: scale3d(1.1, 1.1, 1);
          }
        }
        @keyframes fill {
          100% {
            box-shadow: inset 0px 0px 0px 30px #4bb71b;
          }
        }
      }
    }
  }
</style>
